import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-serif mb-2">We.Tour</h3>
            <p className="text-gray-400 text-sm">Local Tours by Local College Students</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 tracking-wide">CONTACT</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <span className="text-sm">16 Washington Pl, New York, NY 10003</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span className="text-sm">760-4599-775</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span className="text-sm">we.tourcontact@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex justify-center space-x-6 mb-8">
          <a href="https://www.instagram.com/we.tournyc/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors" aria-label="Instagram">
            <Instagram className="w-6 h-6" />
          </a>
        </div>

        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/guides" className="text-sm hover:text-gray-400 transition-colors">GUIDE</Link>
            <Link to="/tours" className="text-sm hover:text-gray-400 transition-colors">TOURS</Link>
            <Link to="/explore-schools" className="text-sm hover:text-gray-400 transition-colors">EXPLORE SCHOOLS</Link>
            <Link to="/about_us" className="text-sm hover:text-gray-400 transition-colors">ABOUT US</Link>
            <Link to="/contacts" className="text-sm hover:text-gray-400 transition-colors">CONTACT US</Link>
          </div>
          <p className="text-center text-sm text-gray-500 mt-6">We.Tour</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;